<div class="main disinfection-panel">
  <div class="title-btn-layout">
    <div class="main-title">
      <h1>Disinfection Panel</h1>
      <p>Monitor disinfection insights and actions</p>
    </div>
    <div class="new-placement">
      <a routerLink="/add-disinfection" class="btn btn-action-primary">
        <i class="fas fa-plus"></i> New Program
      </a>
    </div>
  </div>

  <!-- Insights Panel for Disinfection -->
  <app-disinfection></app-disinfection>
</div>
